import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import styled, { css } from 'styled-components';

const Progressbar = styled(CircularProgressbar)`
  width: 12rem;
  height: 12rem;
  max-height: 60%;
  max-width: 60%;
  margin: auto;
`;

const StyledLoaderWrapper = styled.div`
  ${({ theme: { color } }) => css`
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    max-height: 100%;
    height: 100%;
    max-width: 100%;
    width: 100%;
    color: white;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 3rem;
    overflow: hidden;
    background: ${color.midnight5};
  `}
`;

const StyledUnityLoader = (props) => {
  const [progressCount, setProgressCount] = useState(0);

  // // gets flavour text based on the current progress (as progress goes up, the flavour text will change)
  // // an alternative method might be to do it on an interval
  // const getFlavourText = (progress) => {
  //   const percIncrement=  100 / props.loadingFlavourTexts.length;
  //   // return first text that goes over current progress
  //   for(let i = 0; i < props.loadingFlavourTexts.length; i++){
  //     if(progress > i * percIncrement){
  //       return props.loadingFlavourTexts[i];
  //     }
  //   }
  //   // shouldn't reach this point
  //   return 'Loading...';
  // }

  const progress = useMemo(() => {
    if (props.progress < 90) {
      return props.progress;
    } else {
      return Math.floor(
        90 + Math.min((Math.atan(progressCount) / (Math.PI / 2)) * 10, 99)
      );
    }
  }, [props.progress, progressCount]);

  useEffect(() => {
    let mounted = true;
    setTimeout(() => {
      if (mounted && props.progress > 89) {
        setProgressCount(progressCount + 0.1);
      }
    }, 100);

    return () => (mounted = false);
  }, [props.progress, progressCount]);

  return (
    <StyledLoaderWrapper>
      <Progressbar
        value={props.progress ? progress : 0}
        text={`${progress}${
          props.progress && (progress + '').includes('%') ? '' : '%'
        }`}
        strokeWidth={7}
        styles={buildStyles({
          // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
          strokeLinecap: 'round',
          textSize: '1.5rem',
          // Colors
          pathColor: 'var(--primary-color)',
          textColor: 'var(--unity-loader-text-color)',
          trailColor: 'var(--unity-loader-trail-color)',
          backgroundColor: 'var(--unity-loader-bg-color)',
        })}
      />
    </StyledLoaderWrapper>
  );
};

StyledUnityLoader.propTypes = {
  progress: PropTypes.number,
  loadingFlavourTexts: PropTypes.arrayOf(PropTypes.string),
};

export default StyledUnityLoader;
